/* unplugin-vue-components disabled */import { render } from "./dictionarySelect.vue?vue&type=template&id=5b0c3601"
import script from "./dictionarySelect.vue?vue&type=script&lang=js"
export * from "./dictionarySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__